import { render, staticRenderFns } from "./ModalAddMonthly.vue?vue&type=template&id=3488b8fa&lang=pug&"
import script from "./ModalAddMonthly.vue?vue&type=script&lang=js&"
export * from "./ModalAddMonthly.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddMonthly.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports